export default __webpack_public_path__ + "static/media/KillerJupiter1.811bc5aa.jpg";